//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider, Tag, Select, Option, Col, Button, Upload, Checkbox} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
import CySelect from '../../../components/select/CySelect'
import CyAutocomplete from '../../../components/autocompletes/CyAutocomplete'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Checkbox)
export default {
  name: 'StockOutConfirm',
  components: {
    CyMobileLayout,
    CySelect,
    CyAutocomplete
  },
  data () {
    return {
      materialList: [],
      jzFlag: true,
      weightFlag: false,
      pictureFlag: false,
      xzFlag: false,
      planId: this.$route.query.planId,
      baseInfo: {},
      cargoList: [],
      truckList: [],
      stockOut: {stockout_trailer_plan_id: '', truck_no: '', truck_driver: '', truck_mobile: ''}, // 入库信息
      stockOutCargoList: [{goods_name: '', goods_package_name: '', stockout_number: '', stockout_weight: '', stockout_db_weight: '', stockout_volume: '', storage_position_code: ''}],
      stockOutMaterialList: [{material_name: '', amount: ''}],
      fileList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    truckSelectChange: function (truck) {
      this.stockOut.stockout_container_plan_id = truck.stockout_container_plan_id
      this.stockOut.container_no = truck.container_no
      this.stockOut.seal_no = truck.seal_no
      this.stockOut.truck_no = truck.truck_no
      this.stockOut.truck_driver = truck.truck_driver
      this.stockOut.truck_mobile = truck.truck_mobile
    },
    init: function () {
      let that = this
      let url = '/wms/stockout/confirm/getStockOutPlanInfo'
      console.log(that.planId)
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          that.baseInfo = res.data.baseInfo
          that.cargoList = res.data.cargoList
          that.truckList = res.data.truckList
          that.stockOutCargoList = res.data.cargoList
          that.ctnFlag = that.baseInfo.stockout_ctn_flag === 1
          that.jzFlag = that.baseInfo.cargo_supervision_flag === 1
          that.weightFlag = that.baseInfo.cargo_weight_flag === 1
          that.pictureFlag = that.baseInfo.cargo_picture_flag === 1
          that.xzFlag = that.baseInfo.cargo_fumigation_flag === 1
          that.stockOut.stockout_plan_id = that.baseInfo.stockout_plan_id
          // 根据仓库companyid获取库位列表
          that.getMaterialList()
        }
      })
    },

    getMaterialList: function () {
      let that = this
      let url = '/inter/reinforcematerial/getMaterialListForSelect'
      that.$axiosWeb.post(url).then(function (res) {
        if (res.meta.success) {
          that.materialList = res.data
        }
      })
    },

    addCargo: function (type) {
      let that = this
      that.stockOutCargoList.push({goods_name: '', goods_package_name: '', stockout_number: '', stockout_weight: '', stockout_db_weight: '', stockout_volume: '', storage_position_code: ''})
    },

    deleteCargo: function (cargo, idx, type) {
      this.stockOutCargoList.splice(idx, 1)
    },

    cargoSelected: function (item, cargo, idx) {
      console.log(cargo)
      var numberOut = 0
      var weightOut = 0
      var volumeOut = 0
      cargo.stockout_number = Number(item.goods_number - numberOut).toFixed(0)
      cargo.stockout_weight = Number(item.goods_weight - weightOut + 0.0001).toFixed(2)
      cargo.stockout_volume = Number(item.goods_volume - volumeOut + 0.00001).toFixed(3)
      cargo.stockin_goods_id = item.stockin_goods_id
      cargo.stockout_goods_plan_id = item.stockout_goods_plan_id
      cargo.stockout_plan_id = item.stockout_plan_id
    },

    addMaterial: function () {
      this.stockOutMaterialList.push({material_name: '', amount: ''})
    },
    deleteMaterial: function (idx) {
      this.stockOutMaterialList.splice(idx, 1)
    },

    submitConfirm: function () {
      let that = this
      let url = '/wms/stockout/detail/createStockOutDetail'
      let stockOutParam = {}
      stockOutParam.stockOutDetail = that.stockOut
      stockOutParam.stockOutDetail.stockout_time = that.$Utils.dateFormat(new Date(), 'yyyy-MM-dd')
      if (that.stockOutCargoList.length < 1) {
        that.$Msgbox.alert('请录入出库商品信息', '出库失败')
        return false
      }
      if (that.$Utils.IsEmpty(that.stockOut.stockout_loading_team_id)) {
        that.$Msgbox.alert('请选择装卸队')
        return false
      }

      stockOutParam.goodsList = JSON.stringify(that.stockOutCargoList)
      stockOutParam.materialList = JSON.stringify(that.stockOutMaterialList)
      stockOutParam.fileList = JSON.stringify(that.fileList)
      that.$axiosWeb.post(url, stockOutParam).then(function (res) {
        if (res.meta.success) {
          that.$Msgbox.alert('出库成功', '出库成功')
          location.href = '/wx/wms/stockOutRecordDetail?planId=' + that.planId
        } else {
          that.$Msgbox.alert(res.meta.message, '出库失败')
        }
      })
    },

    uploadSucces: function (res, file, fileList) {
      let that = this
      if (res.meta.success) {
        that.fileList.push({uid: file.uid, name: file.name, url: res.data.fileAbsoluteUrl})
      } else {
        that.$Msgbox.alert(res.meta.message, '错误提示')
      }

      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(this.fileList)
    },

    fileRemoveSucces: function (file, fileList) {
      let that = this
      let uid = file.uid
      let index = that.fileList.findIndex((item) => item.uid === uid)
      that.fileList.splice(index, 1)
      console.log(file)
      console.log(fileList)
      console.log(this.fileList)
    },
    goDetail: function () {
      let that = this
      location.href = '/wx/wms/StockOutRecordDetail?planId=' + that.planId
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockout/StockOutConfirm.vue